import axios from 'axios'

const workerApi = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 600000,
    withCredentials: true,
});
axios.defaults.withCredentials = true;
axios.get('/sanctum/csrf-cookie').then(response => {
});

workerApi.setToken = (token) => {
    workerApi.defaults.headers.common['Authorization'] = 'Bearer ' + token
};

let token = localStorage.getItem('worker_token');
workerApi.setToken(token);
workerApi.setAcceptLanguage = (lang) => {
    workerApi.defaults.headers.common['Accept-Language'] = lang
};

workerApi.interceptors.request.use(function (config) {
    if (!navigator.onLine) {
        return Promise.reject({ message: 'You are offline' });
    }

    return config
}, function (error) {
    return Promise.reject(error)
});

// Add a response interceptor
workerApi.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response) {
        if (error.response.data && _.isObject(error.response.data) && error.response.data.message) {
            error.message = error.response.data.message;
        }
        else if (error.response.data && typeof error.response.data === 'string') {
            error.message = error.response.data;
        }
    }

    return Promise.reject(error)
});

export default workerApi

